const vatNumberRegex =
  /^((AT){1}U[0-9]{8}|(BE){1}0[0-9]{9}|(BG){1}[0-9]{9,10}|(CY){1}[0-9]{8}L|(CZ){1}[0-9]{8,10}|(DE){1}[0-9]{9}|(DK){1}[0-9]{8}|(EE){1}[0-9]{9}|(EL|GR){1}[0-9]{9}|(ES){1}[0-9A-Z][0-9]{7}[0-9A-Z]|(FI){1}[0-9]{8}|(FR){1}[0-9A-Z]{2}[0-9]{9}|(GB){1}[0-9]{9}|(GB){1}([0-9]{9}([0-9]{3}){1}|[A-Z]{2}[0-9]{3})|(HU){1}[0-9]{8}|(IE){1}[0-9]S[0-9]{5}L|(IT){1}[0-9]{11}|(LT){1}([0-9]{9}|[0-9]{12})|(LU){1}[0-9]{8}|(LV){1}[0-9]{11}|(MT){1}[0-9]{8}|(NL){1}[0-9]{9}B[0-9]{2}|(PL){1}[0-9]{10}|(PT){1}[0-9]{9}|(RO){1}[0-9]{2,10}|(SE){1}[0-9]{12}|(SI){1}[0-9]{8}|(SK){1}[0-9]{10})$/i

export function isValidVatNumber(vatNumber: string) {
  return vatNumberRegex.test(getSimplifiedVatNumber(vatNumber))
}

export function getSimplifiedVatNumber(vatNumber: string) {
  return vatNumber.replaceAll(/[^0-9A-Z]?/gi, '').toUpperCase()
}

const naceCodeRegex =
  /^(([A-Z][0-9]{0,2}(\.[0-9]{1,2})?(\.[0-9]{1,2})?)|([A-Z]|[0-9]{1,5}))$/i
export function isValidNaceCode(naceCode: string) {
  return naceCodeRegex.test(naceCode)
}

const websiteRegex =
  // eslint-disable-next-line no-useless-escape
  /^https?:\/\/(www\.)?[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_\+.~#?&//=]*)/i
export function isValidWebsite(website: string) {
  return websiteRegex.test(website)
}

const emailRegex =
  // eslint-disable-next-line no-control-regex
  /^(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9]))\.){3}(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9])|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])$/i
export function isValidEmail(email: string) {
  return emailRegex.test(email)
}

const telephoneRegex =
  // eslint-disable-next-line no-control-regex
  /^(\+|00)[0-9]{2}(\(0\))?(\d| )+$/i
export function isValidTelephone(email: string) {
  return telephoneRegex.test(email)
}

export function isEmpty(value: string | undefined) {
  return value == null || value === ''
}
